import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a9e6f73d-89c3-441c-a239-b2ae763512aa";
export const REGISTER_URL = "https://a.ntrk2.com/b62c7ee8-aa63-49f2-9a88-1aa17529665d";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://phwinwin.loadprkw2a.com/download?openExternalBrowser=1&id=9c3tqvczjrnigy2";

export * from "./codes";
export * from "./context";
